import { Controller } from "stimulus";

// TODO(jon): This is a wholesale import from global script. Need to make this more Stimulus-style, using targets.
const coinsParams = {
  btc: {
    difficulty: 1590000000000,
    blockReward: 12.5,
    blockTime: 600
  }, // 1 block / 600s = 1 block / 10min
  ltc: {
    difficulty: 1736261,
    blockReward: 25,
    blockTime: 150
  },
  eth: {
    difficulty: 1950000000000000,
    blockReward: 2.91,
    blockTime: 17
  },
  xmr: {
    difficulty: 423,
    blockReward: 5.888419,
    blockTime: 120
  },
  dash: {
    difficulty: 62759315,
    blockReward: 1.80147602,
    blockTime: 156
  },
  zec: {
    difficulty: 5438697.546,
    blockReward: 10.000928,
    blockTime: 150
  }
};

// Note: +x casts x into a float.
// E.g.: +"1.1" -> 1.1
//       +1.1   -> 1.1
const difficultyParams = {
  btc: {
    source: "https://chain.so/api/v2/get_info/BTC",
    extractor({ data: { mining_difficulty } }) {
      return +mining_difficulty;
    }
  },
  ltc: {
    source: "https://chain.so/api/v2/get_info/LTC",
    extractor({ data: { mining_difficulty } }) {
      return +mining_difficulty;
    }
  },
  eth: {
    source: "/en/coins/ethereum/difficulty",
    extractor({ difficulty }) {
      if (difficulty) {
        return +difficulty;
      } else {
        // Use fallback value
        coinsParams["eth"].difficulty;
      }
    }
  },
  xmr: {
    source: "https://jsonp.afeld.me/?url=https://moneroblocks.info/api/get_stats",
    extractor({ hashrate }) {
      return +hashrate;
    }
  },
  dash: {
    source: "https://explorer.dash.org/chain/Dash/q/getdifficulty",
    extractor(difficulty) {
      return +difficulty;
    }
  },
  zec: {
    source: "https://api.zcha.in/v2/mainnet/network",
    extractor({ difficulty }) {
      return +difficulty;
    }
  }
};

const input = {
  btc: {
    price: 16884,
    hashRate: 14000,
    multiplier: 1000000000,
    powerConsumption: 1600, // W
    powerCost: 0.12
  }, // $/kWh
  ltc: {
    price: 1000,
    hashRate: 1000,
    multiplier: 1000,
    powerConsumption: 800,
    powerCost: 0.12
  },
  eth: {
    price: 500,
    hashRate: 100,
    multiplier: 1000000,
    powerConsumption: 150,
    powerCost: 0.1
  },
  xmr: {
    price: 245,
    hashRate: 2000,
    multiplier: 1,
    powerConsumption: 600,
    powerCost: 0.12
  },
  dash: {
    price: 700,
    hashRate: 15000,
    multiplier: 1000000,
    powerConsumption: 1200,
    powerCost: 0.1
  },
  zec: {
    price: 300,
    hashRate: 1180,
    multiplier: 1,
    powerConsumption: 600,
    powerCost: 0.1
  }
};

const output = {};

const activateMiningCalculator = function() {
  if (!$("#mining-calculator").length) {
    return;
  }

  // 0. Maybe show loading screen?
  // 1. Fetch coins params (e.g., difficulty, block time). Hardcode for now
  // 2. Render defaults
  initializeDefaults();
  renderDefaults();

  // 3. Attach event listeners
  attachEventListeners();

  // 4. Initial update and initial render
  for (var coin in coinsParams) {
    updateOutput(coin);
  }
  for (coin in coinsParams) {
    updateDifficulty(coin);
  }
  return updateUI();
};

var initializeDefaults = function() {
  $("input[data-coin][data-attribute]").each(function() {
    const coin = $(this).data("coin");
    const attribute = $(this).data("attribute");
    const value = $(this).val();
    if (value !== "") {
      return (input[coin][attribute] = +value);
    }
  });

  return (() => {
    const result = [];
    for (let coin in coinsParams) {
      const params = coinsParams[coin];
      const cacheKey = getDifficultyCacheKeyForCoin(coin);
      result.push((params.difficulty = getFromCache(cacheKey, 1e9) || params.difficulty));
    }
    return result;
  })();
};

var renderDefaults = () => {
  const result = [];
  for (var coin in input) {
    var params = input[coin];

    const res = [];
    for (let attr in params) {
      const value = params[attr];
      res.push($(`[data-coin=${coin}][data-attribute=${attr}]`).val(value));
    }
    result.push(res);
  }
  return result;
};

var attachEventListeners = () =>
  $("#mining-calculator").on("input", "[data-coin][data-attribute]", function() {
    const coin = $(this).data("coin");
    const attribute = $(this).data("attribute");
    input[coin][attribute] = +$(this).val();
    updateOutput(coin);
    return updateUI();
  });

var updateOutput = function(coin) {
  let blockTime;
  const { hashRate, multiplier } = input[coin];
  const effectiveHashRate = hashRate * multiplier;

  const { powerConsumption, powerCost } = input[coin];
  // Compute the amount of energy consumed in 24 hours in kWh.
  const cost = (powerConsumption * powerCost * 24) / 1000;

  // ##########################################
  // Mining Formula documentation from Daniel
  // ##########################################
  // General: Daily reward ≈ blockDay * blockReward * userHashRate/(networkHashRate)
  // Bitcoin and Litecoin ≈ userHashRate/(difficulty*2^32)*blockReward*3600*hashFactor (hashFactor=24)
  // Ethereum and Monero ≈ userHashRate/totalHashRate*blockReward*3600*hashFactor (hashFactor = 24)
  // Zcash ≈ userHashRate/(difficulty*solsPerDiff)*blockReward*3600*hashFactor (solsPerDiff = 8192, hashFactor=24)
  // Dash ≈ userHashRate/(difficulty*1.024*2^22)*blockReward*3600*hashFactor (hashFactor=24).
  //
  // Resources:
  // https://bitcoin.stackexchange.com/questions/8568/equation-for-mining-profit/8600
  // https://monero.stackexchange.com/questions/6647/how-many-hashes-are-needed-to-solve-a-monero-block-of-difficulty-1
  // https://forum.z.cash/t/earnings-formula/13598
  // https://www.dash.org/forum/threads/what-formula-is-used-to-calculate-dash-mining-profitability.16350/
  // https://www.dash.org/forum/threads/what-formula-is-used-to-calculate-dash-mining-profitability.16350/

  switch (coin) {
    case "btc":
    case "ltc":
    case "dash":
      var { difficulty, blockReward } = coinsParams[coin];
      var coinRevenue =
        (effectiveHashRate * blockReward * 60 * 60 * 24) / (difficulty * Math.pow(2, 32));

      var { price } = input[coin];
      var fiatRevenue = coinRevenue * price;

      return (output[coin] = { coinRevenue, fiatRevenue, cost });
    case "eth":
      var userHashPower = effectiveHashRate;

      ({ difficulty, blockTime } = coinsParams.eth);
      var totalHashPower = difficulty / blockTime;

      var userPowerProportion = userHashPower / totalHashPower;

      ({ blockReward } = coinsParams.eth);
      coinRevenue = (blockReward / blockTime) * 60 * 60 * 24 * userPowerProportion;

      ({ price } = input.eth);
      fiatRevenue = coinRevenue * price;

      return (output.eth = { coinRevenue, fiatRevenue, cost });
    case "xmr":
      ({ blockTime } = coinsParams.xmr);
      userHashPower = effectiveHashRate;

      ({ difficulty } = coinsParams.xmr);
      totalHashPower = difficulty;

      userPowerProportion = userHashPower / totalHashPower;

      ({ blockReward } = coinsParams.xmr);
      coinRevenue = (blockReward / blockTime) * 60 * 60 * 24 * userPowerProportion;

      ({ price } = input.xmr);
      fiatRevenue = coinRevenue * price;

      return (output.xmr = { coinRevenue, fiatRevenue, cost });
    case "zec":
      var HASH_FACTOR = 24;

      ({ difficulty, blockReward } = coinsParams.zec);
      coinRevenue = (effectiveHashRate * blockReward * HASH_FACTOR * 60 * 60) / (difficulty * 8192);

      ({ price } = input.zec);
      fiatRevenue = coinRevenue * price;

      return (output.zec = { coinRevenue, fiatRevenue, cost });
  }
};

var updateDifficulty = function(coin) {
  const setDifficulty = function(difficulty) {
    coinsParams[coin].difficulty = difficulty;
    updateOutput(coin);
    return updateUI();
  };

  const cacheKey = getDifficultyCacheKeyForCoin(coin);

  const cachedDifficulty = getFromCache(cacheKey);

  if (cachedDifficulty) {
    return setDifficulty(cachedDifficulty);
  } else {
    return fetchDifficulty(coin).then(function(difficulty) {
      setDifficulty(difficulty);
      return saveToCache(cacheKey, difficulty);
    });
  }
};

var fetchDifficulty = function(coin) {
  if (!(coin in difficultyParams)) {
    return Promise.reject(`Difficulty for ${coin} not supported.`);
  }

  return fetch(difficultyParams[coin].source, { credentials: "same-origin" })
    .then(response => response.json())
    .then(difficultyParams[coin].extractor);
};

// Render results
var updateUI = function() {
  $("span[data-coin][data-attribute]").each(function() {
    const coin = $(this).data("coin");
    const duration = +$(this).data("duration") || 1;
    const attribute = $(this).data("attribute");
    const value = (() => {
      switch (attribute) {
        case "cost":
          return output[coin].cost * duration;
        case "coinRevenue":
          return output[coin].coinRevenue * duration;
        case "fiatRevenue":
          return output[coin].fiatRevenue * duration;
        case "profit":
          return (output[coin].fiatRevenue - output[coin].cost) * duration;
        case "profitRatio":
          return ((output[coin].fiatRevenue - output[coin].cost) / output[coin].cost) * 100;
        case "blockTime":
          return coinsParams[coin].blockTime;
        case "price":
          return input[coin].price;
        case "blockReward":
          return coinsParams[coin].blockReward;
        case "difficulty":
          return coinsParams[coin].difficulty;
        case "powerCost":
          return input[coin].powerCost;
      }
    })();

    const format = (() => {
      switch (attribute) {
        case "profitRatio":
          return "0,0";
        case "blockTime":
        case "blockReward":
          return "0";
        default:
          // For value < 10k, display as it is. (It doesn't save much to display e.g., 2,100 vs 2.1k)
          // For value > 10t, display it as Xt. (Numeral.js doesn't go beyond t. Hence for values
          // significantly larger than 1t, it doesn't make sense to include more figures e.g.,
          // 12345t vs 12345.6t)
          if (Math.abs(value) >= 10 * Math.pow(10, 12)) {
            return "0,0a";
          } else if (Math.abs(value) >= 10000) {
            return "0,0.0a";
          } else {
            return "0,0.00";
          }
      }
    })();

    const text = numeral(value)
      .format(format)
      .toUpperCase();

    return $(this).text(text);
  });

  return $(".calculator-result[data-coin]").each(function() {
    const coin = $(this).data("coin");
    const profit = output[coin].fiatRevenue - output[coin].cost;
    return $(this).toggleClass("loss", profit < 0);
  });
};

var getDifficultyCacheKeyForCoin = coin => `${coin}Difficulty`;

// Local storage cache
var getFromCache = function(key, ttl) {
  if (ttl == null) {
    ttl = 10;
  }
  if (!window.localStorage) {
    return;
  }

  const cache = window.localStorage.getItem(key);

  if (!cache) {
    return;
  }

  try {
    const cacheContent = JSON.parse(cache);
    if (cacheContent.timestamp && +new Date() < cacheContent.timestamp + ttl) {
      return cacheContent.value;
    }
  } catch (error) {}
};

var saveToCache = function(key, value) {
  if (!window.localStorage) {
    return;
  }

  const cacheContent = {
    value,
    timestamp: +new Date()
  };

  const cache = JSON.stringify(cacheContent);
  return window.localStorage.setItem(key, cache);
};

export default class extends Controller {
  static targets = [];

  connect() {
    activateMiningCalculator();
  }
}



// WEBPACK FOOTER //
// ./app/assets/webpack/controllers/mining_calculator_controller.js